import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ItineraryService } from 'app/shared/itinerary.service';
import { RestService } from 'app/shared/rest.service';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'usb-item-boat',
  templateUrl: './item-boat.component.html',
  styleUrls: ['./item-boat.component.scss'],
  providers: [CurrencyConverterPurePipe]
})
export class ItemBoatComponent {

  @Input() dato: any;
  @Input() isCheckIn: boolean;
  @Input() partialReserve: boolean;
  @Input() permissions: any[] = [];
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  @Output() itemDelete = new EventEmitter<any>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();

  bsModalRef?: BsModalRef;

  constructor(
    private itineraryService: ItineraryService,
    private currencyPipe: CurrencyConverterPurePipe,
    private modalService: BsModalService,
    private ngxSpinner: NgxSpinnerService,
    private restService: RestService,
    private notificationService: NotificationService,
    public userService: UserService
  ) {}

  get boat(): any {
    return this.dato?.additionalInfo?.boat;
  }

  get skipperIncluded(): boolean {
    return !!this.dato?.additionalInfo?.skipper?.included;
  }

  get category(): string {
    return this.boat?.category || this.dato?.category || '';
  }

  get location(): string {
    return this.dato?.additionalInfo?.location || this.dato?.origin || '';
  }

  get isRefundable(): boolean {
    return this.dato?.rateClass === 'R';
  }

  getImageCover(): string {
    const images = this.dato?.additionalInfo?.images || this.dato?.images || [];
    const cover = images.find((image: any) => image.is_cover === 1) || images[0];
    return cover?.thumbnail || cover?.image || 'assets/img/app/hotel_default.png';
  }

  getPrice(): number {
    if (this.dato?.status_id === 5) {
      return 0;
    }
    if (this.dato?.isPendigApprovePay || this.dato?.isPaidAgency || this.dato?.isPaidProvider) {
      return this.dato?.converted_amounts?.netPriceAgent ?? this.dato?.netPriceAgent ?? 0;
    }
    return this.currencyPipe.transform(
      this.dato?.netPriceAgent,
      this.dato?.currency,
      this.currencyAgency?.code,
      this.currencies
    ) || 0;
  }

  removeItem(item: any): void {
    const isCancel = item.status_id === 2;
    const initialState: ModalOptions = {
      initialState: {
        title: isCancel ? 'Cancelar' : 'Eliminar',
        message: (isCancel ? '¿Esta seguro de cancelar el producto?' : 'Esta seguro de Eliminar el Producto?').replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        const iataCode = item.destination?.iata_code;
        this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
          if (destination.iata_code === iataCode) {
            destination.destination_info.adults -= Number(item.paxAdults);
            destination.destination_info.childs -= Number(item.paxChildren);
          }
        });

        if (item.status_id === 1 || item.status_id === 5) {
          this.deleteItem(item);
        }
        if (item.status_id === 2) {
          this.cancelReservation(item);
        }
      }
      confirmSubscription.unsubscribe();
    });
  }

  private deleteItem(item: any): void {
    this.itineraryService.remove(item);
    setTimeout(() => {
      this.delete.emit(item.id);
      this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  private cancelReservation(item: any): void {
    this.ngxSpinner.show();
    const cancelData = {
      providerId: item?.providerId,
      reservationLocator: item?.resultReserve?.reservation?.providerReservationId,
      productsId: [item.id]
    };

    const itemCancelled = this.userService.itineraryActive[0].items.find((c: any) => c.id === item.id);
    // Las políticas de cancelación de los barcos todavía no vienen del proveedor.
    itemCancelled.amount_convert_cancellation = [{
      currency: this.currencyAgency?.code,
      from: new Date(),
      amount: 0,
      apply: false
    }];
    this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

    this.restService.doPut('app', `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
      next: () => {
        this.ngxSpinner.hide();
        this.cancel.emit(item.id);
        this.notificationService.success('Su producto fue cancelado con éxito');
        this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
      },
      error: (error: HttpErrorResponse) => {
        this.ngxSpinner.hide();
        this.notificationService.error('Ocurrio un error');
        console.log(error);
      }
    });
  }
}
